<template>
    <vOrderLineListComponent :postList="postList" v-if="flag"></vOrderLineListComponent>
</template>
<script>
import vOrderLineListComponent from '../../listComponent/order/OrderLineListComponent.vue';
export default {
    name: 'orderLineList',
    components: {
        vOrderLineListComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                order_rid: true,
                order_name: true,
                product_rid: true,
                addBtn: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },

            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>